import { render, staticRenderFns } from "./ActivityFilter.vue?vue&type=template&id=179a92d2&scoped=true&"
import script from "./ActivityFilter.vue?vue&type=script&lang=js&"
export * from "./ActivityFilter.vue?vue&type=script&lang=js&"
import style0 from "./ActivityFilter.vue?vue&type=style&index=0&id=179a92d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179a92d2",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/ActivityTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fcbs%2Factivity%2FActivityFilter.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports